import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { clinic } from '../data/navigation';
export function ConsultationCTA() {
  return <section id="consultation" className="bg-ink py-20 lg:py-28" data-id="element-11" data-mp="f8w9m74rh0vn">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-12" data-mp="j96roi5tvhqv">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_0.8fr] lg:items-end lg:gap-20" data-id="element-13" data-mp="o0y7bxng4328">
          <div data-id="element-14" data-mp="o2sw5n1u8fbl">
            <p className="text-[0.65rem] uppercase tracking-overline text-champagne" data-id="element-15" data-mp="t0b69grld0l6">
              Consultations
            </p>
            <h2 className="mt-5 max-w-2xl text-3xl font-light leading-[1.15] tracking-[-0.02em] text-white sm:text-[2.75rem]" data-id="element-16" data-mp="xy2y6as8kmpd">
              Begin with a private consultation
            </h2>
            <p className="mt-6 max-w-lg text-base leading-[1.85] text-white/70" data-id="element-17" data-mp="1703vf7ngz8r1">
              Same-week availability at our Kendall office. Tell us what you&rsquo;re
              considering and we&rsquo;ll arrange time with Dr. Sara — surgical or
              non-surgical.
            </p>
          </div>

          <div className="flex flex-col gap-4" data-id="element-18" data-mp="375lpkviwblgb">
            <a href={clinic.phoneHref} className="flex items-center justify-center gap-2 bg-white px-8 py-4 text-xs uppercase tracking-overline text-ink transition-colors duration-150 ease-soft hover:bg-champagne hover:text-ink" data-id="element-19" data-mp="376dejnhzmkxm">
              <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="2sh7clrrrmgm1" />
              {clinic.phoneDisplay}
            </a>
            <a href={`mailto:${clinic.email}`} className="border border-white/25 px-8 py-4 text-center text-xs uppercase tracking-overline text-white transition-colors duration-150 ease-soft hover:border-champagne hover:text-champagne" data-id="element-21" data-mp="3q124b2x64os7">
              Request a Consultation
            </a>
            <p className="mt-2 flex items-start gap-2 text-sm leading-relaxed text-white/60" data-id="element-22" data-mp="24ql7a895bafq">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-23" data-mp="1zr8nxxhhglhw" />
              <span data-id="element-24" data-mp="rrjnstjrkihz">
                {clinic.addressLine1}
                <br data-id="element-25" data-mp="rs1fdcvhe8jk" />
                {clinic.addressLine2}
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}